/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_GenericInputs */

const en_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred. Please try again.`)
};

const fr_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite. Veuillez réessayer.`)
};

const de_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`)
};

const it_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore. Riprova.`)
};

const ru_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Произошла ошибка. Пожалуйста, попробуйте еще раз.`)
};

const es_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha producido un error. Inténtalo de nuevo.`)
};

const zh_cn2_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发生错误，请重试。`)
};

const ja_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラーが発生しました。もう一度お試しください。`)
};

const hi_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक त्रुटि हुई थी। कृपया दोबारा प्रयास करें।`)
};

const pt_pt2_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "An error occurred. Please try again." |
*
* @param {Login_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_generic = /** @type {((inputs?: Login_Error_GenericInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_GenericInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_generic(inputs)
	if (locale === "de") return de_login_error_generic(inputs)
	if (locale === "it") return it_login_error_generic(inputs)
	if (locale === "ru") return ru_login_error_generic(inputs)
	if (locale === "es") return es_login_error_generic(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_generic(inputs)
	if (locale === "ja") return ja_login_error_generic(inputs)
	if (locale === "hi") return hi_login_error_generic(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_generic(inputs)
	return en_login_error_generic(inputs)
});